import AppProvider from './context/AppProvider'
import Content from './components/content/Content'
import Load from './components/load/Load'
import './App.css';

function App() {
  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Content />
      </div>
    </AppProvider>
    
  );
}

export default App;
